'use client';

import React, { useState } from 'react';
import TextArea from '@/components/atoms/text-area';
import EditIcon from './EditIcon';
import useMediaQuery from '@/hooks/useMediaQuery';
import { desktop } from '@/constants/screensizes';
import Spinner from '@/components/organisms/spinner';

const OtherDetails = ({ deliveryInstructions = '' }: { deliveryInstructions?: string }) => {
    const [isDesktop] = useMediaQuery(desktop);
    const headerFontCss = isDesktop ? 'text-28' : 'text-20';
    const textAreaCss = isDesktop ? 'text-20' : 'text-14';
    const [isNavigating, setIsNavigating] = useState(false);

    return (
        <>
            {isNavigating && <Spinner />}

            {isNavigating && (
                <div className="overlay fixed left-0 top-0 z-50 h-full w-full bg-gray-800 opacity-75"></div>
            )}
         <div className='mt-4 mb-4 bg-[#FFFFFF] p-4'>
        <div className='otherdetails ' id="other-details">
            <h3 className={`font-semibold ${headerFontCss}`}>3. Other Details</h3>
            <div className='flex justify-between w-full h-24 min-h-[80px] !border-[#D7D7D7] border rounded-md mt-6 p-2'>
                <div className='w-full'>
                    <TextArea disabled className={`border-none font-medium !bg-[#FFFFFF] !text-[#828282] w-full ${textAreaCss}`} value={deliveryInstructions} placeholder={"No information added"} />
                </div>
                <EditIcon location='/checkout/#other-details' onClick={() => setIsNavigating(true)}/>
            </div>

        </div>
    </div>
    </>
    )
};

export default OtherDetails;
